<div class="container">
  <form #copyPermisosForm *ngIf="!showResume">
    <div class="row mb-5">
      <div class="col-lg-6 mb-6 mx-auto">
        <app-title-with-back>Copiar permisos de Usuario</app-title-with-back>
        <label for="identificacion-afiliado"> Usuario a copiar: <span class="required-mark">*</span> </label>
        <ng-select
          #usuarioFuentePermisos
          name="identificacion-usuario"
          #usuarioIdentificacion="ngModel"
          [items]="coincidenciaUsuarios$ | async"
          [typeahead]="usuariosInput$"
          bindLabel="email"
          placeholder="nombre, email, cedula"
          [(ngModel)]="usuario"
          class="full-height-ng-select"
          [class.is-invalid]="usuarioIdentificacion.invalid && usuarioIdentificacion.touched"
          [loading]="loadingUsuario"
          required
        >
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="ng-select-option-card mx-3 my-1">
              <div class="nombre">
                <strong>Nombre: </strong>
                {{ item.nombreCompleto }}
              </div>
              <div class="numero-afiliado"><strong> Email: </strong> {{ item.email }}</div>
              <div class="identificacion"><strong> Identificación: </strong> {{ item.identificacion }}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div *ngIf="usuario && usuario.usuarioRole.length > 0" class="row">
      <div class="col-lg-6 mb-4 mx-auto">
        <div class="roles-container">
          <div class="roles-header">{{ usuario.email }}</div>
          <div class="roles-body">
            <div class="roles-body-header mb-2">Roles</div>
            <div *ngFor="let item of usuario.usuarioRole; let indice = index" class="roles-row-container font-weight-normal">
              <div class="col-md-6 roles-row font-weight-normal mb-2">{{ item.role.nombre }}</div>
              <div class="col-md-6 roles-row-desc mb-2">{{ item.role.descripcion }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="usuario">
      <div class="col-lg-6 mb-6 mx-auto">
        <h3 uni-heading alignText="center" class="mb-4 mt-4">Usuarios destino</h3>
      </div>
    </div>
    <div class="row" *ngIf="usuario">
      <div class="col-lg-6 mb-6 mx-auto">
        <div class="content-box dotted">
          <ng-select
            #usuariosDestinosSelection
            name="identificacion-usuario-destino"
            #UsuarioDeDestino="ngModel"
            (change)="addToUsuariosDestino($event)"
            [items]="coincidenciaUsuariosDestino$ | async"
            [typeahead]="usuariosInputDestino$"
            placeholder="nombre, email, cedula"
            [(ngModel)]="usuarioDestino"
            class="full-height-ng-select"
            bindLabel=""
            [class.is-invalid]="UsuarioDeDestino.invalid && UsuarioDeDestino.touched"
            [loading]="loadingUsuarioDestino"
            required
          >
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="ng-select-option-card mx-3 my-1">
                <div class="nombre">
                  <strong>Nombre: </strong>
                  {{ item.nombreCompleto }}
                </div>
                <div class="numero-afiliado"><strong> Email: </strong> {{ item.email }}</div>
                <div class="identificacion"><strong> Identificación: </strong> {{ item.identificacion }}</div>
              </div>
            </ng-template>
          </ng-select>
          <div class="mt-4 container-user-destino" *ngIf="usuariosDestinos.length > 0">
            <div
              class="box-item bold space-dotted-box mb-2 font-weight-normal position-relative"
              *ngFor="let item of usuariosDestinos; let indice = index"
            >
              <span class="text-info mr-4">{{ item?.id }}</span
              ><span>{{ item?.email }}</span>
              <button
                size="sm"
                class="float-right"
                uni-icon-button
                variant="danger"
                [filled]="true"
                (click)="borrarUsuario(item)"
              >
                <uni-icon name="x"></uni-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4" *ngIf="usuario">
      <div class="col-lg-6 mb-6 mx-auto">
        <div class="d-flex justify-content-between">
          <div class="custom-align-center">
            <label
              ><input name="reiniciarLosPermisos" type="checkbox" [(ngModel)]="reiniciarPermisos" class="mr-2" /> Reiniciar los
              permisos de estos usuarios</label
            >
          </div>
          <div class="custom-align-center">
            <label
              ><input name="copiarIntermediarioUnit" type="checkbox" [(ngModel)]="copiarIntermediarioUnit" class="mr-2" /> Copiar
              intermediario de Unit
            </label>
          </div>
          <div class="text-right">
            <button
              uni-button
              (click)="copiarPermisos()"
              [disabled]="!usuario || usuario.usuarioRole.lengthx < 1 || (usuariosDestinos && usuariosDestinos.length < 1)"
            >
              Ejecutar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="showResume" class="row">
    <div class="col-lg-6 mb-5 mt-5 mx-auto">
      <h1 uni-heading color="primary" class="mb-5 mt-0 text-center text-primary">Copiar permisos de Usuario</h1>
      <div class="m-alert-success icon mb-4">
        <h2 uni-heading color="success" class="mt-3">¡Usuarios copiados exitosamente!</h2>
      </div>
      <div class="resume-container">
        <div>
          <div class="resume-header">
            <div class="row font-weight-bold">
              <div class="col-sm-6">Usuario:</div>
              <div class="col-sm-6">Código:</div>
            </div>
            <div class="row font-weight-light">
              <div class="col-sm-6 font-weight-normal">{{ usuario.email }}</div>
              <div class="col-sm-6 font-weight-normal">{{ usuario.id }}</div>
            </div>
          </div>
          <div class="resume-body">
            <div class="row">
              <div class="col-md-12 font-weight-bold mb-1">Roles</div>
            </div>
            <div class="row mb-3 font-weight-light" *ngFor="let item of usuario.usuarioRole; let indice = index">
              <div class="col-md-6 mb-2 font-weight-normal">{{ item.role.nombre }}</div>
              <div class="col-md-6 mb-2 font-weight-normal">{{ item.role.descripcion }}</div>
              <div class="col-md-12">
                <div [ngClass]="{ underline: indice < usuario.usuarioRole.length }" class="w-100"></div>
              </div>
            </div>

            <div class="row font-weight-bold mt-3 mb-3">
              <div class="col-md-6">Usuarios destino</div>
              <div class="col-md-6">Código</div>
            </div>

            <div *ngFor="let item of usuariosDestinos; let indice = index" class="row mb-3 font-weight-light">
              <div class="col-md-6 mb-2 font-weight-normal">{{ item.email }}</div>
              <div class="col-md-6 mb-2 font-weight-normal">{{ item.id }}</div>
              <div class="col-md-12">
                <div [ngClass]="{ underline: indice < usuariosDestinos.length }" class="w-100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right mt-4">
        <button uni-button (click)="copiarOtroUsuario()">Copiar otro usuario</button>
      </div>
    </div>
  </div>
</div>
